/**
 * CloseIcon Component
 *
 * Close/dismiss icon for chips, dialogs, etc.
 * Based on Figma design: 14x14 diagonal cross.
 */

export function CloseIcon({ className }: { className?: string }) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <path d="M0.530273 0.530273L14.5303 14.5303" stroke="currentColor" strokeWidth="1.5" />
      <path d="M14.5303 0.530273L0.530273 14.5303" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  );
}
